import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Send } from "lucide-react";
import { api } from "../lib/api";
import { STATUS_OPTIONS, formatErr, inputCls, labelCls } from "../lib/constants";
import CorrectionList from "../components/CorrectionList";

const todayTR = () => new Date().toLocaleDateString("en-CA", { timeZone: "Europe/Istanbul" });
const empty = { personnel_id: "", date: "", requested_status: "", note: "" };

export default function CorrectionRequest() {
  const [personnel, setPersonnel] = useState([]);
  const [requests, setRequests] = useState([]);
  const [form, setForm] = useState({ ...empty, date: todayTR() });
  const [saving, setSaving] = useState(false);

  const loadRequests = () => api.get("/corrections").then((r) => setRequests(r.data));
  useEffect(() => { api.get("/personnel").then((r) => setPersonnel(r.data)); loadRequests(); }, []);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.post("/corrections", form);
      toast.success("Düzeltme talebi İK'ya iletildi");
      setForm({ ...empty, date: todayTR() });
      loadRequests();
    } catch (err) { toast.error(formatErr(err)); }
    setSaving(false);
  };

  return (
    <div className="max-w-4xl mx-auto space-y-5">
      <div className="glass-card hud-corners p-5">
        <h1 className="font-display text-xl font-bold text-cyan-300 tracking-widest uppercase text-glow-sm">Düzeltme Talebi Oluştur</h1>
        <p className="text-sm text-slate-400 mt-1">Kaydedilmiş puantajlar kilitlidir. Hatalı bir kayıt için talep açın; İK onayladığında tablo otomatik güncellenir.</p>
        <form onSubmit={submit} className="mt-5 grid grid-cols-1 md:grid-cols-2 gap-3">
          <div><label className={labelCls}>Personel</label>
            <select data-testid="cr-personnel" required value={form.personnel_id} onChange={set("personnel_id")} className={inputCls}>
              <option value="">Seçin</option>
              {personnel.map((p) => <option key={p.id} value={p.id}>#{p.sira_no} {p.full_name}</option>)}
            </select>
          </div>
          <div><label className={labelCls}>Tarih</label>
            <input data-testid="cr-date" type="date" required max={todayTR()} value={form.date} onChange={set("date")} className={inputCls} />
          </div>
          <div className="md:col-span-2"><label className={labelCls}>Doğru Kod</label>
            <div className="flex flex-wrap gap-2">
              {STATUS_OPTIONS.map((s) => (
                <button type="button" key={s.code} data-testid={`cr-status-${s.code}`} onClick={() => setForm((f) => ({ ...f, requested_status: s.code }))}
                  className={`px-3 py-1.5 rounded-full text-[11px] font-mono uppercase border transition ${form.requested_status === s.code ? s.cls + " ring-2 ring-current" : "border-slate-700 text-slate-400 hover:border-cyan-500/40"}`}>
                  {s.label}
                </button>
              ))}
            </div>
          </div>
          <div className="md:col-span-2"><label className={labelCls}>Açıklama</label>
            <textarea data-testid="cr-note" required minLength={3} rows={3} value={form.note} onChange={set("note")} className={inputCls} placeholder="Örn. Personel raporlu idi, yanlışlıkla Çalışıyor girildi." />
          </div>
          <button data-testid="cr-submit" disabled={saving || !form.requested_status} className="md:col-span-2 btn-cyan py-3 rounded-lg font-display font-bold tracking-widest uppercase text-sm disabled:opacity-40 flex items-center justify-center gap-2">
            <Send className="w-4 h-4" /> {saving ? "Gönderiliyor..." : "İK'ya İlet"}
          </button>
        </form>
      </div>

      <div className="glass-card p-5">
        <h3 className="font-display text-sm font-bold text-cyan-300 tracking-widest uppercase mb-3">Taleplerim</h3>
        <CorrectionList items={requests} />
      </div>
    </div>
  );
}
